import React, { useState, useEffect, useCallback } from 'react';
import { API } from '../App';

const BackupIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
);

const RefreshIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/></svg>
);

const TrashIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-2 14H7L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/></svg>
);

const DownloadIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
);

const RestoreIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"/></svg>
);

const ShieldIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
);

function BackupRow({ backup, type, token, onRefresh }) {
  const [loading, setLoading] = useState(false);
  const [confirmRestore, setConfirmRestore] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(false);

  const handleDownload = () => {
    window.open(`${API}/backup/${type}/${backup.backup_id}/download?token=${token}`, '_blank');
  };

  const handleRestore = async () => {
    if (!confirmRestore) { setConfirmRestore(true); return; }
    setLoading(true);
    try {
      const res = await fetch(`${API}/backup/datos/${backup.backup_id}/restore`, {
        method: 'POST', headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await res.json();
      if (res.ok) {
        alert(`Restauracion completada:\n${data.collections_restored?.length || 0} colecciones\n${data.uploads_restored || 0} archivos`);
      } else {
        alert(`Error: ${data.detail || 'Error desconocido'}`);
      }
    } catch (e) { alert(`Error: ${e.message}`); }
    setLoading(false);
    setConfirmRestore(false);
    onRefresh();
  };

  const handleDelete = async () => {
    if (!confirmDelete) { setConfirmDelete(true); return; }
    setLoading(true);
    try {
      await fetch(`${API}/backup/${type}/${backup.backup_id}`, {
        method: 'DELETE', headers: { 'Authorization': `Bearer ${token}` }
      });
      onRefresh();
    } catch (e) { alert(`Error: ${e.message}`); }
    setLoading(false);
    setConfirmDelete(false);
  };

  const date = new Date(backup.created_at);
  const dateStr = date.toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' });
  const timeStr = date.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' });
  const cols = backup.meta?.mongodb?.collections?.length || 0;
  const uploads = backup.meta?.uploads_count || 0;

  return (
    <div data-testid={`backup-row-${backup.backup_id}`} style={{
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      padding: '12px 16px', background: backup.success ? 'rgba(76,175,80,0.08)' : 'rgba(233,69,96,0.08)',
      borderRadius: '8px', marginBottom: '8px', border: `1px solid ${backup.success ? 'rgba(76,175,80,0.2)' : 'rgba(233,69,96,0.2)'}`,
      flexWrap: 'wrap', gap: '8px'
    }}>
      <div style={{ flex: '1 1 200px', minWidth: '150px' }}>
        <div style={{ fontSize: '14px', fontWeight: '600', color: '#e0e0e0' }}>
          {dateStr} {timeStr}
        </div>
        <div style={{ fontSize: '12px', color: '#888', marginTop: '2px' }}>
          {backup.size_mb} MB | {cols} cols | {uploads} archivos
          {backup.created_by && ` | por ${backup.created_by}`}
        </div>
        {!backup.success && <div style={{ fontSize: '12px', color: '#e94560', marginTop: '2px' }}>{backup.error}</div>}
        {!backup.file_exists && <div style={{ fontSize: '11px', color: '#ff9800' }}>Archivo no encontrado en disco</div>}
      </div>
      <div style={{ display: 'flex', gap: '6px', flexShrink: 0 }}>
        {backup.file_exists && (
          <button data-testid={`download-${backup.backup_id}`} onClick={handleDownload} disabled={loading}
            style={{ padding: '6px 10px', background: '#1a5276', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '12px', display: 'flex', alignItems: 'center', gap: '4px' }}>
            <DownloadIcon /> Descargar
          </button>
        )}
        {type === 'datos' && backup.file_exists && (
          <button data-testid={`restore-${backup.backup_id}`} onClick={handleRestore} disabled={loading}
            style={{ padding: '6px 10px', background: confirmRestore ? '#e94560' : '#1a6030', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '12px', display: 'flex', alignItems: 'center', gap: '4px' }}>
            <RestoreIcon /> {confirmRestore ? 'Confirmar?' : 'Restaurar'}
          </button>
        )}
        <button data-testid={`delete-${backup.backup_id}`} onClick={handleDelete} disabled={loading}
          style={{ padding: '6px 10px', background: confirmDelete ? '#e94560' : '#4a1a1a', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '12px', display: 'flex', alignItems: 'center', gap: '4px' }}>
          <TrashIcon /> {confirmDelete ? 'Seguro?' : 'Borrar'}
        </button>
      </div>
    </div>
  );
}

export default function Backups() {
  const [status, setStatus] = useState(null);
  const [datosBackups, setDatosBackups] = useState([]);
  const [appBackups, setAppBackups] = useState([]);
  const [loading, setLoading] = useState(false);
  const [creating, setCreating] = useState(null);
  const token = localStorage.getItem('token');

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const headers = { 'Authorization': `Bearer ${token}` };
      const [statusRes, datosRes, appRes] = await Promise.all([
        fetch(`${API}/backup/status`, { headers }),
        fetch(`${API}/backup/datos`, { headers }),
        fetch(`${API}/backup/aplicacion`, { headers }),
      ]);
      if (statusRes.ok) setStatus(await statusRes.json());
      if (datosRes.ok) setDatosBackups(await datosRes.json());
      if (appRes.ok) setAppBackups(await appRes.json());
    } catch (e) { console.error('Error fetching backups:', e); }
    setLoading(false);
  }, [token]);

  useEffect(() => { fetchData(); }, [fetchData]);

  const createBackup = async (type) => {
    setCreating(type);
    try {
      const res = await fetch(`${API}/backup/${type}`, {
        method: 'POST', headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await res.json();
      if (res.ok) {
        alert(`Backup ${type} iniciado: ${data.backup_id}\nSe ejecuta en segundo plano. Recibiras un email al terminar.`);
        setTimeout(fetchData, 5000);
      } else {
        alert(`Error: ${data.detail || 'Error desconocido'}`);
      }
    } catch (e) { alert(`Error: ${e.message}`); }
    setCreating(null);
  };

  return (
    <div data-testid="backups-page" style={{ maxWidth: '900px', margin: '0 auto', padding: '20px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '24px' }}>
        <button data-testid="backups-volver" onClick={() => window.history.length > 1 ? window.history.back() : (window.location.href = '/')}
          style={{ padding: '8px', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '8px', color: '#d4af37', cursor: 'pointer', lineHeight: 0 }} title="Volver">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/></svg>
        </button>
        <ShieldIcon />
        <div>
          <h1 style={{ fontSize: '24px', fontWeight: '700', color: '#d4af37', margin: 0 }}>Sistema de Backups</h1>
          <p style={{ color: '#888', margin: '4px 0 0', fontSize: '14px' }}>Protege los datos y la aplicacion de Mallorca Klan</p>
        </div>
        <button data-testid="refresh-backups" onClick={fetchData} disabled={loading}
          style={{ marginLeft: 'auto', padding: '8px', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '8px', color: '#fff', cursor: 'pointer' }}>
          <RefreshIcon />
        </button>
      </div>

      {/* Status Cards */}
      {status && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '16px', marginBottom: '32px' }}>
          <div data-testid="status-datos" style={{ background: 'linear-gradient(135deg, #1a3a2e 0%, #16213e 100%)', padding: '20px', borderRadius: '12px', border: '1px solid rgba(76,175,80,0.2)' }}>
            <div style={{ fontSize: '13px', color: '#4caf50', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '1px' }}>Backups de Datos</div>
            <div style={{ fontSize: '28px', fontWeight: '700', color: '#e0e0e0', margin: '8px 0' }}>{status.datos.count} <span style={{ fontSize: '14px', color: '#888' }}>/ {status.datos.max}</span></div>
            <div style={{ fontSize: '12px', color: '#888' }}>{status.datos.size_mb} MB total</div>
            {status.datos.last && <div style={{ fontSize: '11px', color: '#666', marginTop: '4px' }}>
              Ultimo: {new Date(status.datos.last.created_at).toLocaleDateString('es-ES')} {status.datos.last.success ? '(OK)' : '(FALLO)'}
            </div>}
          </div>
          <div data-testid="status-app" style={{ background: 'linear-gradient(135deg, #1a2a3e 0%, #16213e 100%)', padding: '20px', borderRadius: '12px', border: '1px solid rgba(33,150,243,0.2)' }}>
            <div style={{ fontSize: '13px', color: '#2196f3', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '1px' }}>Backups de Aplicacion</div>
            <div style={{ fontSize: '28px', fontWeight: '700', color: '#e0e0e0', margin: '8px 0' }}>{status.aplicacion.count} <span style={{ fontSize: '14px', color: '#888' }}>/ {status.aplicacion.max}</span></div>
            <div style={{ fontSize: '12px', color: '#888' }}>{status.aplicacion.size_mb} MB total</div>
            {status.aplicacion.last && <div style={{ fontSize: '11px', color: '#666', marginTop: '4px' }}>
              Ultimo: {new Date(status.aplicacion.last.created_at).toLocaleDateString('es-ES')} {status.aplicacion.last.success ? '(OK)' : '(FALLO)'}
            </div>}
          </div>
        </div>
      )}

      {/* Type 1: Data Backups */}
      <div style={{ marginBottom: '32px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
          <div>
            <h2 style={{ fontSize: '18px', color: '#4caf50', margin: 0 }}>Backup de Datos</h2>
            <p style={{ fontSize: '12px', color: '#666', margin: '4px 0 0' }}>MongoDB + archivos subidos. Hot backup sin parar servicios.</p>
          </div>
          <button data-testid="create-datos-backup" onClick={() => createBackup('datos')} disabled={creating === 'datos'}
            style={{ padding: '10px 20px', background: creating === 'datos' ? '#333' : '#1a6030', color: '#fff', border: 'none', borderRadius: '8px', cursor: creating === 'datos' ? 'wait' : 'pointer', fontSize: '14px', fontWeight: '600', display: 'flex', alignItems: 'center', gap: '8px' }}>
            <BackupIcon /> {creating === 'datos' ? 'Creando...' : 'Crear Backup'}
          </button>
        </div>
        {datosBackups.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '40px', color: '#555', background: 'rgba(255,255,255,0.02)', borderRadius: '8px' }}>No hay backups de datos</div>
        ) : (
          datosBackups.map(b => <BackupRow key={b.backup_id} backup={b} type="datos" token={token} onRefresh={fetchData} />)
        )}
      </div>

      {/* Type 2: Application Backups */}
      <div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
          <div>
            <h2 style={{ fontSize: '18px', color: '#2196f3', margin: 0 }}>Backup de Aplicacion</h2>
            <p style={{ fontSize: '12px', color: '#666', margin: '4px 0 0' }}>Snapshot completo: codigo + BD + config. Para pre-actualizaciones.</p>
          </div>
          <button data-testid="create-app-backup" onClick={() => createBackup('aplicacion')} disabled={creating === 'aplicacion'}
            style={{ padding: '10px 20px', background: creating === 'aplicacion' ? '#333' : '#1a4a6a', color: '#fff', border: 'none', borderRadius: '8px', cursor: creating === 'aplicacion' ? 'wait' : 'pointer', fontSize: '14px', fontWeight: '600', display: 'flex', alignItems: 'center', gap: '8px' }}>
            <BackupIcon /> {creating === 'aplicacion' ? 'Creando...' : 'Crear Backup'}
          </button>
        </div>
        {appBackups.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '40px', color: '#555', background: 'rgba(255,255,255,0.02)', borderRadius: '8px' }}>No hay backups de aplicacion</div>
        ) : (
          appBackups.map(b => <BackupRow key={b.backup_id} backup={b} type="aplicacion" token={token} onRefresh={fetchData} />)
        )}
      </div>
    </div>
  );
}
